import { getEnvironmentVariables } from "@/common/utils/env/envSettings.js";
import { STARGET_CLIENT_ID, STARGET_CLIENT_SECRET_ID, RUM_DASHBOARD_API_TOKEN } from "./envConfig.js";

export function getCurrentEnvironmentVariables() {
  return constants.ENVIRONMENTS[getEnvironmentVariables().label];
}

export const constants = {
  APP_BASE: "main-holder",
  ENVIRONMENTS: {
    localhost: {
      assetsUrl: "https://assetst.maerskline.com",
      apiDomain: {
        v1: "https://api-stage.maersk.com/{type}/v1",
        v2: "https://api-stage.maersk.com/{type}/v2"
      },
      fileApiDomain: {
        v1: "https://api-cdt.maersk.com/{type}/v1"
      },
      label: "localhost",
      redirectUri: "http://localhost:8080",
      azureRedirectUri: "http://localhost:8080",
      applicationName: "GCD-DEV",
      apiKey: RUM_DASHBOARD_API_TOKEN,
      accessTokenConfiguration: {
        accessTokenEndPoint: "https://api-stage.maersk.com/oauth2/access_token",
        clientId: STARGET_CLIENT_ID,
        clientSecret: STARGET_CLIENT_SECRET_ID,
        frozenETAEndPoint: "https://api-stage.maersk.com/gcd-vessel-schedule/v1/portcall/update-frozen-eta"
      },
      env: "dev"
    },
    dev: {
      assetsUrl: "https://assetst.maerskline.com",
      apiDomain: {
        v1: "https://gcd-{type}-dev.maersk-digital.net/v1",
        v2: "https://gcd-{type}-dev.maersk-digital.net/v2"
      },
      label: "dev",
      redirectUri: "https://gcdagent-dev.maersk.com/",
      azureRedirectUri: "https://gcdagentdev.azurewebsites.net/",
      applicationName: "GCD-Dev",
      apiKey: RUM_DASHBOARD_API_TOKEN,
      accessTokenConfiguration: {
        accessTokenEndPoint: "https://api-cdt.maersk.com/oauth2/access_token",
        clientId: STARGET_CLIENT_ID,
        clientSecret: STARGET_CLIENT_SECRET_ID,
        frozenETAEndPoint: "https://api-cdt.maersk.com/gcd-vessel-schedule/v1/portcall/update-frozen-eta"
      },
      env: "dev"
    },
    qa: {
      assetsUrl: "https://assetst.maerskline.com",
      apiDomain: {
        v1: "https://api-cdt.maersk.com/{type}/v1",
        v2: "https://api-cdt.maersk.com/{type}/v2"
      },
      fileApiDomain: {
        v1: "https://api-cdt.maersk.com/{type}/v1"
      },
      label: "qa",
      redirectUri: "https://gcd-qa.maersk.com/",
      azureRedirectUri: "https://gcdagentqa.azurewebsites.net/",
      applicationName: "GCD-QA",
      apiKey: RUM_DASHBOARD_API_TOKEN,
      accessTokenConfiguration: {
        accessTokenEndPoint: "https://api-cdt.maersk.com/oauth2/access_token",
        clientId: STARGET_CLIENT_ID,
        clientSecret: STARGET_CLIENT_SECRET_ID,
        frozenETAEndPoint: "https://api-cdt.maersk.com/gcd-vessel-schedule/v1/portcall/update-frozen-eta"
      },
      env: "qa"
    },
    perf: {
      assetsUrl: "https://assetst.maerskline.com",
      apiDomain: {
        v1: "https://gcd-{type}-perf.maersk-digital.net/v1",
        v2: "https://gcd-{type}-perf.maersk-digital.net/v2"
      },
      label: "perf",
      redirectUri: "https://gcd-perf.maersk.com/",
      azureRedirectUri: "https://gcdagentperf.azurewebsites.net/",
      applicationName: "GCD-Perf",
      apiKey: RUM_DASHBOARD_API_TOKEN,
      accessTokenConfiguration: {
        accessTokenEndPoint: "https://api-stage.maersk.com/oauth2/access_token",
        clientId: STARGET_CLIENT_ID,
        clientSecret: STARGET_CLIENT_SECRET_ID,
        frozenETAEndPoint: "https://api-stage.maersk.com/gcd-vessel-schedule/v1/portcall/update-frozen-eta"
      },
      env: "perf"
    },
    preprod: {
      assetsUrl: "https://assetsd.maerskline.com",
      apiDomain: {
        v1: "https://api-stage.maersk.com/{type}/v1",
        v2: "https://api-stage.maersk.com/{type}/v2"
      },
      fileApiDomain: {
        v1: "https://api-cdt.maersk.com/{type}/v1"
      },
      label: "preprod",
      redirectUri: "https://gcd-preprod.maersk.com/",
      azureRedirectUri: "https://gcdagentpreprod.azurewebsites.net/",
      applicationName: "GCD-Preprod",
      apiKey: RUM_DASHBOARD_API_TOKEN,
      accessTokenConfiguration: {
        accessTokenEndPoint: "https://api-stage.maersk.com/oauth2/access_token",
        clientId: STARGET_CLIENT_ID,
        clientSecret: STARGET_CLIENT_SECRET_ID,
        frozenETAEndPoint: "https://api-stage.maersk.com/gcd-vessel-schedule/v1/portcall/update-frozen-eta"
      },
      env: "preprod"
    },
    prod: {
      assetsUrl: "https://assets.maerskline.com",
      apiDomain: {
        v1: "https://api.maersk.com/{type}/v1",
        v2: "https://api.maersk.com/{type}/v2"
      },
      fileApiDomain: {
        v1: "https://api.maersk.com/{type}/v1"
      },
      label: "prod",
      redirectUri: "https://gcd.maersk.com/",
      azureRedirectUri: "https://gcdagent.azurewebsites.net/",
      applicationName: "GCD-Prod",
      apiKey: RUM_DASHBOARD_API_TOKEN,
      accessTokenConfiguration: {
        accessTokenEndPoint: "https://api.maersk.com/oauth2/access_token",
        clientId: STARGET_CLIENT_ID,
        clientSecret: STARGET_CLIENT_SECRET_ID,
        frozenETAEndPoint: "https://api.maersk.com/gcd-vessel-schedule/v1/portcall/update-frozen-eta"
      },
      env: "Prod"
    }
  },
  countryAPIUrl: "https://api.maersk.com/customer-identity/countries", //since GCD doesn't have an dedicated API service
  pageSettings: {
    exception: {
      dateRangePeriod: 14, //refers in days,
      isDateRangeFilterDefaulted: true,
      groupSearchResultsPerPage: 20,
      dateType: [
        {
          value: "eta",
          label: "Estimated Schedule Time"
        },
        {
          value: "deadline",
          label: "Submission deadline"
        }
      ],
      filters: {
        groupFilterDropdown: [
          {
            value: "",
            id: "",
            label: "Select Any"
          }
        ], //change the name based on our requiement
        manifestFilterCheckbox: [
          "DATAQUALITYCHECKFAILED",
          "NON_CRITICAL_DQE",
          "MISSINGREFRENCE",
          "REJECTED",
          "MISSINGDEADLINE",
          "RETURNCARGO",
          "MISSINGHBL",
          "ELECTRONIC_SUBMISSION_EXPIRED",
          "AUTO_SUBMISSION_DISABLED",
          "SUBMISSION_ERROR"
        ] //TODO: need to check with backend team for unique string
      },
      exceptionType: new Map([["Data Quality Check Failed", "dqe"]])
    },
    notfication: {
      dateRangePeriod: 14, //refers in days,
      isDateRangeFilterDefaulted: true,
      resultsPerPage: 10,
      defaultSortBy: "notificationDate",
      defaultFetchType: "ACTIVE_ACTION",
      fileTypeAccepted: ".pdf,.jpeg,.jpg,.png,.doc,.docx",
      customsName: [
        { name: "FI", value: "Finnish Customs" },
        { name: "HK", value: "Hongkong Customs" },
        { name: "EU", value: "EU Customs" }
      ],
      filter: {
        mappingCountry: {
          FI: "Finland",
          HK: "Hong Kong",
          US: "United States",
          CA: "Canada",
          DK: "Denmark",
          EU: "ENS ICS2"
        }
      },
      manifestTypes: {
        US: ["Export Manifest", "Import Manifest", "Import Empty Manifest", "Advance Manifest", "Import Rail Manifest"],
        CA: [
          "Export Manifest",
          "Import Manifest",
          "Import Empty Manifest",
          "Advance Manifest",
          "House Bill Import Manifest"
        ],
        JP: ["Import Manifest", "Import Empty Manifest", "Vessel Arrival Notification"]
      },
      isEditCreateNotification: ["US", "CA", "PR"],
      documentTypes: [
        {
          name: "Other document",
          label: "Other document",
          value: "1ZZZ"
        },
        {
          name: "Loading List",
          label: "Loading List",
          value: "2270"
        }
      ],
      shipmentIndicator: [
        {
          name: "Nil cargo",
          label: "Nil cargo",
          value: "N"
        },
        {
          name: "Cancel shipment",
          label: "Cancel shipment",
          value: "C"
        },
        {
          name: "Off - hired",
          label: "Off - hired",
          value: "F"
        }
      ],
      contactReasons: [
        {
          name: "Request for amendment after the release of the goods",
          label: "Request for amendment after the release of the goods",
          value: "001"
        },
        { name: "Invalidation request", label: "Invalidation request", value: "002" },
        {
          name: "Request for time-limit extension",
          label: "Request for time-limit extension",
          value: "003"
        },
        {
          name: "Error notification response; I do not see the same need to amend the declaration details",
          label: "Error notification response; I do not see the same need to amend the declaration details",
          value: "004"
        },
        {
          name: "Cancellation for earlier change request",
          label: "Cancellation for earlier change request",
          value: "005"
        },
        { name: "Other reason", label: "Other reason", value: "006" },
        {
          name: "Bill of discharge / notification of discharge",
          label: "Bill of discharge / notification of discharge",
          value: "007"
        },
        {
          name:
            "en: Tiedoksianto väliaikaisen maahantuonnin jälleenviennistä tai asettamisesta muuhun tullimenettelyyn (OSI)",
          label:
            "en: Tiedoksianto väliaikaisen maahantuonnin jälleenviennistä tai asettamisesta muuhun tullimenettelyyn (OSI)",
          value: "008"
        },
        {
          name: "Response for hearing request, approval of the proposal",
          label: "Response for hearing request, approval of the proposal",
          value: "010"
        }
      ],
      rfiResponseOptions: [
        { value: "RIR", label: "manifest.notification.rfi.response.rir.text" },
        { value: "RIJ", label: "manifest.notification.rfi.response.rij.text" }
      ]
    },
    manifest: {
      searchResultsPerPage: 10,
      filters: {
        dateRangePeriod: 14, //refers in days,
        isDateRangeFilterDefaulted: true,
        dateType: [
          {
            value: "eta",
            label: "ETA"
          },
          {
            value: "etd",
            label: "ETD"
          },
          {
            value: "ata",
            label: "ATA"
          },
          {
            value: "atd",
            label: "ATD"
          },
          {
            value: "deadline",
            label: "Submission deadline"
          }
        ],
        vsaPartner: [
          {
            value: "vsapartner",
            label: "VSA partner"
          },
          {
            value: "vsapartner1",
            label: "VSA partner1"
          },
          {
            value: "vsapartner2",
            label: "VSA partner2"
          }
        ],
        mappingComplainceType: {
          //key: ?t=import%20manifest" the url parameter and value is same as the data we get from API mapped to name which we are not sending to backend as per the team
          //if we have used name, we didn't wanted this mapping :(
          //key: url param "?t" -- value: name from complaine-type API basedata
          "import manifest": "import",
          "export manifest": "export",
          "export manifest - exs": "export-exs",
          "advance manifest": "advance",
          "bay plan": "bay-plan",
          "transit manifest": "transit",
          "empty manifest": "empty",
          "import empty manifest": "import-empty",
          "export empty manifest": "export-empty",
          "veterinary cargo manifest": "veterinary-cargo",
          "phytosanitary manifest": "phytosanitary ",
          "foreign departure notification": "foreign-departure-notification",
          "vessel arrival notification": "vessel-arrival-notification",
          "vessel departure notification": "vessel-departure-notification",
          "vessel pre departure notification": "vessel-pre-departure-notification",
          "vessel pre arrival notification": "vessel-pre-arrival-notification",
          "temporary storage declaration": "temporary-storage-declaration",
          "presentation notification": "presentation-notification",
          "terminal import manifest": "terminal-import",
          "house bill import manifest": "house-bill-import",
          "house bill advance manifest": "house-bill-advance",
          "arrival at port of exit": "arrival-port-exit",
          "departure from port of exit": "departure-port-exit",
          "coastwise empty manifest": "coast-empty",
          "eda revision notification": "eda-revision-notification",
          "import rail manifest": "import-rail",
          "lns house bill advance manifest": "lns-house-bill-advance-manifest",
          "presentation of goods manifest": "presentation-of-goods-manifest",
          "transhipment export manifest": "transhipment-export"
        },
        disableApproveButton: ["DK", "SG", "SE", "JP", "EU", "HR"],
        okToLoadCountry: ["US", "GB", "CA", "EU"],
        cargoTypeFilterCountry: ["IN"],
        okToLoadPeopleAndWeightInfo: [],
        mailTemplate: {
          "United States": {
            errorType: ["Missing Reference", "Data Quality Check Failed", "Awaiting SI Processing"]
          },
          Canada: {
            errorType: ["Missing Reference", "Data Quality Check Failed", "Awaiting SI Processing"]
          },
          "Puerto Rico": {
            errorType: ["Missing Reference", "Data Quality Check Failed", "Awaiting SI Processing"]
          }
        },
        mappingCountry: {
          GB: "Great Britain",
          CA: "Canada",
          DK: "Denmark",
          US: "United States",
          FI: "Finland",
          TZ: "Tanzania",
          SG: "Singapore",
          HK: "Hong Kong",
          LK: "Sri Lanka",
          KH: "Cambodia",
          EU: "European Customs Union",
          GM: "Gambia",
          IE: "Ireland",
          BH: "Bahrain",
          DE: "Germany",
          BE: "Belgium",
          SE: "Sweden",
          JP: "Japan",
          JO: "Jordan",
          ZA: "South Africa",
          CY: "Cyprus",
          AE: "United Arab Emirates",
          HR: "Croatia",
          RO: "Romania",
          IT: "Italy"
        },
        showBrandManifestSummary: [
          "advance manifest",
          "import manifest",
          "export manifest",
          "export manifest - exs",
          "temporary storage declaration",
          "vessel pre departure notification",
          "terminal import manifest",
          "house bill import manifest",
          "house bill advance manifest",
          "arrival at port of exit",
          "departure from port of exit",
          "presentation of goods manifest"
        ],
        loadPortEnable: {
          "advance manifest": "Advance Manifest",
          "bay plan": "Bay Plan",
          "foreign departure notification": "Foreign Departure Notification",
          "import rail manifest": "Import Rail Manifest"
        },
        etaSubmissionType: [
          "advance manifest",
          "import manifest",
          "presentation notification",
          "temporary storage declaration",
          "terminal import manifest",
          "house bill import manifest",
          "house bill advance manifest",
          "vessel-pre-arrival-notification",
          "bay plan"
        ],
        mappingManifestType: {
          "import manifest": "Import Manifest",
          "import empty manifest": "Import Empty Manifest",
          "export manifest": "Export Manifest",
          "export manifest - exs": "Export Manifest - EXS",
          "export empty manifest": "Export Empty Manifest",
          "coastwise empty manifest": "Coastwise Empty Manifest",
          "advance manifest": "Advance Manifest",
          "transit manifest": "Transit Manifest",
          "empty manifest": "Empty Manifest",
          "presentation notification": "Presentation Notification",
          "temporary storage declaration": "Temporary Storage Declaration",
          "veterinary cargo manifest": "Veterinary Cargo Manifest",
          "phytosanitary manifest": "Phytosanitary Manifest ",
          "vessel arrival notification": "Vessel Arrival Notification",
          "vessel departure notification": "Vessel Departure Notification",
          "vessel pre departure notification": "Vessel Pre Departure Notification",
          "vessel pre arrival notification": "Vessel Pre Arrival Notification",
          "terminal import manifest": "Terminal Import Manifest",
          "house bill import manifest": "House Bill Import Manifest",
          "house bill advance manifest": "House Bill Advance Manifest",
          "arrival at port of exit": "Arrival at Port of Exit",
          "departure from port of exit": "Departure from Port of Exit",
          "bay plan": "Bay Plan",
          "eda revision notification": "EDA Revision Notification",
          "foreign departure notification": "Foreign Departure Notification",
          "import rail manifest": "Import Rail Manifest",
          "lns house bill advance manifest": "LnS House Bill Advance Manifest",
          "presentation of goods manifest": "Presentation of Goods Manifest",
          "transhipment export manifest": "Transhipment Export Manifest"
        },
        grossWeight: 0,
        vsaPartnerEnabledCountryList: ["DK"],
        notificationV2CountryList: ["EU"],
        exportManifests: [
          "export manifest",
          "export manifest - exs",
          "arrival at port of exit",
          "departure from port of exit",
          "export empty manifest",
          "coastwise empty manifest",
          "transhipment export manifest"
        ]
      },
      operators: {
        SEA: {
          ype: "seau",
          imagePath: require("@/assets/logo/seau.svg")
        },
        MCC: {
          ype: "seau",
          imagePath: require("@/assets/logo/seau.svg")
        },
        SGL: {
          ype: "seau",
          imagePath: require("@/assets/logo/seau.svg")
        },
        MSL: {
          type: "maeu",
          imagePath: require("@/assets/logo/maeu.svg")
        },
        MSK: {
          type: "maeu",
          imagePath: require("@/assets/logo/maeu.svg")
        },
        MAE: {
          type: "maeu",
          imagePath: require("@/assets/logo/maeu.svg")
        },
        MLL: {
          type: "maei",
          imagePath: require("@/assets/logo/maei.svg")
        },
        ALL: {
          ype: "seau",
          imagePath: require("@/assets/logo/maeu.svg")
        }
      },
      baplieStatus: {
        active: {
          label: "Active",
          appearance: "neutral-inverse",
          content: null
        },
        "ready for submission": {
          label: "Ready For Submission",
          appearance: "info",
          content: null
        },
        "ready for amendment": {
          label: "Submitted Awaiting Response",
          appearance: "info",
          content: null
        },
        "ready for deletion": {
          label: "Submitted Awaiting Response",
          appearance: "info",
          content: null
        },
        "submitted awaiting response": {
          label: "Submitted Awaiting Response",
          appearance: "info",
          content: null
        },
        "all loads manifested": {
          label: "Approved",
          appearance: "success",
          content: "All loads manifested"
        },
        "approved with warning": {
          label: "Approved with warnings",
          appearance: "info",
          content: null
        },
        "all data element accepted": {
          label: "Approved",
          appearance: "info",
          content: "All data elements accepted"
        },
        approved: {
          label: "Approved",
          appearance: "success",
          content: null
        },
        rejected: {
          label: "Rejected",
          appearance: "error",
          content: null
        },
        "not all loads manifested": {
          label: "Incomplete",
          appearance: "warning",
          content: "Not all loads manifested"
        },
        completed: {
          label: "Completed",
          appearance: "success",
          content: null
        },
        cancelled: {
          label: "Cancelled",
          appearance: "error",
          content: null
        },
        "response not received": {
          label: "Submission Error",
          appearance: "error",
          content: null
        },
        // This is VAN statuses
        "vessel arrived": {
          label: "Vessel Arrived",
          appearance: "success",
          eventCode: "AAD"
        },
        "arrival overdue": {
          label: "Arrival Overdue",
          appearance: "warning",
          eventCode: "OCA"
        },
        "arrival cancelled": {
          label: "Arrival Cancelled",
          eventCode: "COC"
        },
        "on hold": {
          label: "On Hold",
          appearance: "error",
          eventCode: "HMI"
        },
        released: {
          label: "Released",
          appearance: "success",
          eventCode: "HRE"
        },
        "submission error": {
          label: "Submission Error",
          appearance: "error"
        },
        initial: {
          label: "Initial",
          appearance: "info",
          content: null
        },
        invalidated: {
          label: "Invalidated",
          appearance: "warning",
          content: null
        },
        registered: {
          label: "Registered",
          appearance: "info",
          content: null
        },
        "under control": {
          label: "Under Control",
          appearance: "info",
          content: null
        },
        "goods not allowed to be released": {
          label: "Goods not allowed to be released",
          appearance: "error",
          content: null
        },
        "goods to be released": {
          label: "Goods to be released",
          appearance: "success",
          content: null
        },
        // This is a deleted flag
        "port deleted/omitted": {
          label: "Port deleted/omitted",
          appearance: "warning",
          content: null
        }
      },
      baplieStage: {
        Original: "Original",
        Amendment: "Replace",
        Delete: "Delete"
      },
      railStatus: {
        release: {
          label: "Released",
          appearance: "success",
          content: null
        },
        whr: {
          label: "Warehouse released",
          appearance: "success",
          content: null
        },
        export: {
          label: "Exported",
          appearance: "success",
          content: null
        },
        hold: {
          label: "Hold",
          appearance: "error",
          content: null
        },
        "hold removed": {
          label: "Hold removed",
          appearance: "success",
          content: null
        },
        exam: {
          label: "Exam",
          appearance: "error",
          content: null
        },
        "exam completed": {
          label: "Exam completed",
          appearance: "success",
          content: null
        },
        arrival: {
          label: "Arrived",
          appearance: "info",
          content: null
        },
        move: {
          label: "Move authorized",
          appearance: "info",
          content: null
        },
        "permit to transfer authorized": {
          label: "Permit to transfer authorized (Port)",
          appearance: "info",
          content: null
        },
        port: {
          label: "Port",
          appearance: "success",
          content: null
        },
        dnl: {
          label: "Do Not Load",
          appearance: "info",
          content: null
        }
      },
      newSubmissionFlowEnabledCountryManifests: [
        "FITSD",
        "EUADV",
        "CAADV",
        "USADV",
        "CAEXP",
        "USEXP",
        "FITIM",
        "DETSD",
        "BHEXP",
        "BHIMP",
        "JPIMP",
        "JPVAN",
        "JPIEM",
        "JOIMP",
        "JOHIM",
        "EULAM",
        "SEAPE",
        "SEDPE",
        "CYTSD",
        "BETSD",
        "NLIEM",
        "CYPGM",
        "AEADV",
        "HRTIM",
        "GBADV",
        "ROPGM",
        "ITTSD"
      ]
    },
    portcall: {
      rotationNumberDisplayCountries: ["Bahrain"]
    },
    values: {
      IMPORT_MANIFEST: "import manifest",
      EXPORT_MANIFEST: "export manifest",
      EXPORT_MANIFEST_EXS: "Export Manifest - EXS",
      VESSEL_ARRIVAL_NOTIFICATION: "vessel arrival notification",
      VESSEL_PRE_ARRIVAL_NOTIFICATION: "vessel pre arrival notification",
      VESSEL_PRE_DEPARTURE_NOTIFICATION: "vessel pre departure notification",
      PRESENTATION_NOTIFICATION: "presentation notification",
      VESSEL_DEPARTURE_NOTIFICATION: "vessel departure notification",
      FOREIGN_DEPARTURE_NOTIFICATION: "foreign departure notification",
      ADVANCE_MANIFEST: "advance manifest",
      TERMINAL_IMPORT_MANIFEST: "terminal import manifest",
      HOUSE_BILL_IMPORT_MANIFEST: "house bill import manifest",
      HOUSE_BILL_ADVANCE_MANIFEST: "house bill advance manifest",
      ARRIVAL_AT_PORT_OF_EXIT: "arrival at port of exit",
      DEPARTURE_FROM_PORT_OF_EXIT: "departure from port of exit"
    },
    vanVSAPartner: ["MSC", "HSUD"],
    isMaintanenceON: false,
    showUrlMigrationNotification: false, // Flag to show/hide URL migration notification
    isAzureUrlRedirectON: true // Flag to redirect Azure portal URLs to URL migration page
  }
};
